var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.9904 71.0552C60.3619 71.0552 69.5804 61.8387 69.5804 50.4695C69.5804 39.1003 60.3619 29.8838 48.9904 29.8838C37.6188 29.8838 28.4004 39.1003 28.4004 50.4695C28.4004 61.8387 37.6188 71.0552 48.9904 71.0552Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1904 50.4496L46.4704 56.7183L59.0104 44.1809",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.73047 54.3989V56.9184C4.73047 60.1577 7.37047 62.7972 10.6105 62.7972H32.4805",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.73047 47.0604V44.201C4.73047 40.9517 7.37047 38.3223 10.6105 38.3223H32.3605",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7002 91.6711C41.9802 94.6405 44.4902 96.99 47.5502 96.99H89.2002",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5402 62.7871H67.8102C71.0502 62.7871 73.6902 65.4166 73.6902 68.6659V72.2052C73.6902 75.4545 71.0502 78.0839 67.8102 78.0839H47.5402C44.3002 78.0839 41.6602 80.7234 41.6602 83.9627V84.3326",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6602 38.3131H87.3702C90.1802 38.3131 92.5302 36.3331 93.1102 33.6931",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79004 21.7856H87.3701C90.1701 21.7856 92.52 23.7456 93.1 26.3756",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1104 10.2581H58.3604",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1602 6.05908L58.3602 10.2582L54.1602 14.4673",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3302 81.8732C90.7402 81.2833 90.0302 80.9834 89.2002 80.9834C88.3702 80.9834 87.6702 81.2833 87.0702 81.8732C86.4802 82.463 86.1802 83.1729 86.1802 84.0027C86.1802 84.8325 86.4802 85.5324 87.0702 86.1323C87.6602 86.7322 88.3702 87.0221 89.2002 87.0221C90.0302 87.0221 90.7302 86.7222 91.3302 86.1323C91.9202 85.5424 92.2202 84.8325 92.2202 84.0027C92.2202 83.1729 91.9202 82.473 91.3302 81.8732ZM83.6902 78.4939C85.2102 76.9742 87.0502 76.2043 89.2002 76.2043C91.3502 76.2043 93.1802 76.9642 94.7102 78.4939C96.2302 80.0136 97.0002 81.8532 97.0002 84.0027C97.0002 84.9725 96.7302 86.0823 96.1902 87.332C95.6502 88.5818 95.0002 89.7515 94.2402 90.8413C93.4802 91.9311 92.7202 92.9509 91.9502 93.9107C91.1902 94.8605 90.5402 95.6203 90.0002 96.1702L89.1902 97C88.9802 96.7901 88.7002 96.5001 88.3502 96.1302C87.9902 95.7603 87.3702 95.0304 86.4802 93.9507C85.5902 92.8709 84.8002 91.8211 84.1202 90.8113C83.4402 89.8015 82.8102 88.6518 82.2502 87.382C81.6902 86.1123 81.4102 84.9925 81.4102 84.0227C81.4102 81.8732 82.1702 80.0435 83.7002 78.5139L83.6902 78.4939Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.91 6.66882C10.32 6.07894 9.61003 5.77901 8.78003 5.77901C7.95003 5.77901 7.25002 6.07894 6.65002 6.66882C6.06002 7.2587 5.76001 7.96855 5.76001 8.79838C5.76001 9.6282 6.06002 10.3281 6.65002 10.9279C7.24002 11.5278 7.95003 11.8178 8.78003 11.8178C9.61003 11.8178 10.31 11.5178 10.91 10.9279C11.5 10.3381 11.8 9.6282 11.8 8.79838C11.8 7.96855 11.5 7.2687 10.91 6.66882ZM3.28003 3.28952C4.80003 1.76984 6.64001 1 8.79001 1C10.94 1 12.77 1.75984 14.3 3.28952C15.82 4.80921 16.59 6.64882 16.59 8.79838C16.59 9.76818 16.32 10.8779 15.78 12.1277C15.24 13.3774 14.59 14.5472 13.83 15.637C13.07 16.7267 12.31 17.7465 11.54 18.7063C10.78 19.6561 10.13 20.416 9.59003 20.9658L8.78003 21.7957C8.57003 21.5857 8.29 21.2958 7.94 20.9259C7.58 20.5559 6.96001 19.8261 6.07001 18.7463C5.18001 17.6665 4.39002 16.6168 3.71002 15.607C3.03002 14.5972 2.40003 13.4474 1.84003 12.1777C1.28003 10.9079 1 9.78817 1 8.81837C1 6.66882 1.76001 4.8392 3.29001 3.30952L3.28003 3.28952Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.72955 54.399C6.75644 54.399 8.39957 52.7562 8.39957 50.7298C8.39957 48.7033 6.75644 47.0605 4.72955 47.0605C2.70267 47.0605 1.05957 48.7033 1.05957 50.7298C1.05957 52.7562 2.70267 54.399 4.72955 54.399Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2403 33.713C95.2672 33.713 96.9103 32.0702 96.9103 30.0437C96.9103 28.0173 95.2672 26.3745 93.2403 26.3745C91.2134 26.3745 89.5703 28.0173 89.5703 30.0437C89.5703 32.0702 91.2134 33.713 93.2403 33.713Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.67 91.6712C43.6969 91.6712 45.34 90.0285 45.34 88.002C45.34 85.9755 43.6969 84.3328 41.67 84.3328C39.6431 84.3328 38 85.9755 38 88.002C38 90.0285 39.6431 91.6712 41.67 91.6712Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoute);
export default __webpack_public_path__ + "static/media/route.97543188b0241ab7410822fcd6d1812a.svg";
export { ForwardRef as ReactComponent };